import { Amplify } from "aws-amplify";
import { createApolloClient, createCloudApolloClient } from "../graphql/client";
import { createAuthApi } from "./auth";
import {
  createShellHandleHost,
  type ShellHandleHost,
} from "./createShellHandle";
import type { ApolloClient } from "@apollo/client";
import { createConnectivityApi, type ConnectivityApi } from "./connectivity";

export interface BootstrapResult {
  host: ShellHandleHost;
  client: ApolloClient<unknown>;
  cloudClient: ApolloClient<unknown>;
  // One instance for the whole renderer. The probe polls while offline, and
  // the boot branch, the token watcher, the resume signal and the host's
  // partial-outage branch all have to be asking the same question.
  connectivity: ConnectivityApi;
}

export function bootstrapShellHost(): BootstrapResult {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_AWS_USER_POOL_ID,
        userPoolClientId: import.meta.env.VITE_AWS_CLIENT_ID,
        loginWith: { username: true },
      },
    },
  });
  const auth = createAuthApi();
  const client = createApolloClient(auth);
  const cloudClient = createCloudApolloClient(auth);
  const connectivity = createConnectivityApi();
  const host = createShellHandleHost(client, cloudClient, {
    probeOnline: () => connectivity.probe(),
  });
  return { host, client, cloudClient, connectivity };
}
